import React from "react";

export const WaveformBars = ({ active = false, bars = 10, testId }) => {
  return (
    <div
      data-testid={testId}
      className={`flex h-14 items-center justify-center gap-1.5 transition-opacity ${active ? "opacity-100" : "opacity-25"}`}
    >
      {Array.from({ length: bars }).map((_, i) => (
        <span
          key={i}
          className="wave-bar w-1.5 rounded-full bg-[hsl(var(--accent))]"
          style={{
            animationDelay: `${i * 0.09}s`,
            animationPlayState: active ? "running" : "paused",
            height: active ? undefined : "6px",
          }}
        />
      ))}
    </div>
  );
};
